import { render, staticRenderFns } from "./ChoiceComponent.vue?vue&type=template&id=2a0b14ac&scoped=true&"
import script from "./ChoiceComponent.vue?vue&type=script&lang=js&"
export * from "./ChoiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceComponent.vue?vue&type=style&index=0&id=2a0b14ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b14ac",
  null
  
)

export default component.exports